/// <amd-module name="Feed/Legacy/Components/NoResultsPane" />
import * as React from "react";

import { ExternalLink } from "Feed/Legacy/Components/ExternalLink";
import { IVssPageContext } from "VSS/Platform/Context";

export interface INoResultsPaneProps {
    pageContext: IVssPageContext;
    header: string;
    subheader?: string;
    link?: string;
    linkText?: string;
    iconClass: string;
}

export class NoResultsPane extends React.PureComponent<INoResultsPaneProps> {
    public render(): JSX.Element {
        return (
            <div className="no-results-pane">
                <div className={"empty-icon bowtie-icon " + this.props.iconClass} />
                <div className="empty-header">{this.props.header}</div>
                {this.props.subheader ? <div className="empty-subheader">{this.props.subheader}</div> : <div />}
                {this.props.link && this.props.linkText ? (
                    <div className="empty-subheader">
                        <ExternalLink pageContext={this.props.pageContext} href={this.props.link}>
                            {this.props.linkText}
                        </ExternalLink>
                    </div>
                ) : (
                    <div />
                )}
                <div className="no-results-pane-content">{this.props.children}</div>
            </div>
        );
    }
}
